import React from "react";
import { Provider } from "react-redux";
import store from "./store";
import "./App.scss";
import ModalContainer from "./components/modal/modalContainer";
import { BrowserRouter } from "react-router-dom";
import MobileMenuContainer from "./components/mobileMenu/MobileMenuContainer";
import NavigationBridge from "./components/NavigationBridge";
import AppRouter from "./components/appRouter/AppRouter";

export default function App() {
  return (
    <BrowserRouter>
      <Provider store={store}>
        <NavigationBridge />
        <div className="App">
          <AppRouter />
          <ModalContainer />
          <MobileMenuContainer />
        </div>
      </Provider>
    </BrowserRouter>
  );
}
